import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'zentis',
} as IModuleProps;
